module.exports = __webpack_public_path__ + "assets/flags/4x3//e336d50a0531bb958fa92165c55ff083.svg";